interface ExtractedInquirySearchParams {
    startCountry: string;
    fromDate: string;
    toDate: string;
    user: string;
    destinationCountry: string;
    status: string;
    perpage: number;
    client: string;
    service: string;
    amountFrom?: number;
    amountTo?: number;
    minus: boolean;
    noOffer: boolean;
    tab: string
}

interface ExtractedOrderSearchParams {
    startCountry: string;
    fromDate: string;
    toDate: string;
    user: string;
    checker: string;
    serviceType: string;
    destinationCountry: string;
    status: string;
    perPage: string;
    vendor: string;
    client: string;
    amountFrom: string;
    amountTo: string;
    invoiceNumber: string;
    id: string;
    buyInvoice: string;
}

export const extractInquirySearchParams = (id: number|undefined): string => {

    const searchParams = new URLSearchParams(window.location.search);

    const params: ExtractedInquirySearchParams = {
        startCountry: searchParams.get("startCountry") || "0",
        user: searchParams.get("user") || String(id) || "-1",
        fromDate: searchParams.get("fromDate") || '',
        toDate: searchParams.get("toDate") || '',
        destinationCountry: searchParams.get("destinationCountry") || "0",
        status: searchParams.get("status") || "unarchived",
        perpage: Number(searchParams.get("perpage")) || 80,
        client: searchParams.get("client") || "",
        service: searchParams.get("service") || "0",
        amountFrom: Number(searchParams.get("amountFrom")) || undefined,
        amountTo: Number(searchParams.get("amountTo")) || undefined,
        minus: searchParams.get("minus") === "1",
        noOffer: searchParams.get("nooffer") === "1",
        tab: searchParams.get("tab") || 'unanswered',
    };

    const queryString = Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value.toString())}`)
        .join("&");

    return queryString;
};

export const extractExtractedOrderSearchParams = (): string => {
    const searchParams = new URLSearchParams(window.location.search);

    const params: ExtractedOrderSearchParams = {
        startCountry: searchParams.get("startCountry") || '',
        fromDate: searchParams.get("fromDate") || '',
        toDate: searchParams.get("toDate") || '',
        user: searchParams.get("user") || '',
        checker: searchParams.get("checker") || '',
        serviceType: searchParams.get("serviceType") || '',
        destinationCountry: searchParams.get("destinationCountry") || '',
        status: searchParams.get("status") || 'all',
        perPage: searchParams.get("perPage") || '80',
        vendor: searchParams.get("vendor") || '',
        client: searchParams.get("client") || '',
        amountFrom: searchParams.get("amountFrom") || '',
        amountTo: searchParams.get("amountTo") || '',
        invoiceNumber: searchParams.get("invoiceNumber") || '',
        buyInvoice: searchParams.get("buyInvoice") || '',
        id: searchParams.get("id") || '',
    };

    const queryString = Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(value.toString())}`)
        .join('&');

    return queryString;
};